// eslint-disable-next-line
export const stringIncludesSubstring = (substring, string) => {
  return string ? string.search(new RegExp(substring, 'i')) !== -1 : false;
};
